export const columns = [
  {
    accessorKey: "name",
    header: "Type of Payment",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "amount",
    header: "Charges",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "isFixed",
    header: "Variable/Fixed",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.isFixed === 0 ? "Variable Charges" : "Fixed Charges" || " "}`,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
